var map = {
	"./advisionit/background-2.png": "def3",
	"./blue/background-2.png": "665c",
	"./bm/background-2.png": "feac",
	"./bonafarm/background-2.png": "45a9",
	"./eucom/background-2.png": "2c48",
	"./iom/background-2.png": "4044",
	"./mavir-orange/background-2.png": "8c49",
	"./mavir/background-2.png": "cbcb",
	"./mekh/background-2.png": "3b30",
	"./minerva/background-2.png": "90b1",
	"./mvm/background-2.png": "c02c",
	"./neting/background-2.png": "ab04",
	"./nistify/background-2.png": "ef7b",
	"./red/background-2.png": "9855",
	"./skillgo/background-2.png": "22c9",
	"./t4i/background-2.png": "64ad",
	"./unhcr/background-2.png": "a733",
	"./vgye/background-2.png": "605b",
	"./yettel/background-2.png": "7da7"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5a69";